'use es6';

import http from 'hub-http/clients/apiClient';
import { BASE_URI_LC } from '../constants/ApiConstants';
export const LESSON_API_URL = `${BASE_URI_LC}/lessons`;
export const fetchAvailableLanguagesByLessonId = lessonId => http.get(`${LESSON_API_URL}/${lessonId}/available-languages`);